import React from "react";
import { Menu, message } from "antd";
import {
  HomeFilled,
  SearchOutlined,
  UnorderedListOutlined,
  FileTextOutlined,
  UserOutlined,
  HistoryOutlined,
  TableOutlined,
  UploadOutlined,
  HomeOutlined,
  UsergroupDeleteOutlined,
  ContainerOutlined,
} from "@ant-design/icons";
import { Link, withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as userActions from "../../../../actionCreators/User";
import "./style/index.css";

const { SubMenu } = Menu;

const Sidebar = ({ history, logOut, collapsed, user }) => {
  const location = history.location;
  const pathName = location.pathname;
  const subStrPathName = pathName.substring(1);
  const splitPathName = subStrPathName.split("/");

  const sideOpenKey = splitPathName[0].trim();
  const sideSelectedKey = splitPathName[1] ? splitPathName[1].trim() : "";

  const sideMenuSelectedKey =
    sideSelectedKey === "" ? sideOpenKey : `${sideSelectedKey}-${sideOpenKey}`;

  const [userArea, setUserArea] = React.useState("");
  const [isInspector, setIsInspector] = React.useState(true);
  const [isEto, setIsEto] = React.useState(false);
  const [isAdmin, setIsAdmin] = React.useState(true);
  const [propertyKey, setPropertyKey] = React.useState("unregistered");
  const [taxKey, setTaxKey] = React.useState("challans");
  const [selectedKey, setSelectedKey] = React.useState("");
  const [isDistrictAdmin, setIsDistrictAdmin] = React.useState(null);

  React.useEffect(() => {
    if (user) {
      setIsInspector(
        user?.currentUser?.data?.user_roles.findIndex((e) => e.role_id == 1) >=
          0
      );
      setIsAdmin(
        user?.currentUser?.data?.user_roles.findIndex((e) => e.role_id === 3) >=
          0
      );
      setIsEto(
        user?.currentUser?.data?.user_roles.findIndex((e) => e.role_id === 2) >=
          0
      );
      setIsDistrictAdmin(
        user?.currentUser?.data?.user_roles.findIndex((e) => e.role_id === 5) >=
          0
      );
    }
  }, [user]);

  React.useEffect(() => {
    if (splitPathName.includes("properties")) {
      setSelectedKey("/properties");
    } else if (splitPathName.includes("detected")) {
      setSelectedKey("/detected");
    } else if (splitPathName.includes("search-property")) {
      setSelectedKey("/search-property");
    } else if (splitPathName.includes("tax-collection")) {
      setSelectedKey("/tax-collection");
    } else if (
      splitPathName.includes("reports") &&
      splitPathName.includes("overview")
    ) {
      setSelectedKey("/reports/overview");
    } else if (
      splitPathName.includes("reports") &&
      splitPathName.includes("taxInspector")
    ) {
      setSelectedKey("/reports/taxInspector");
    } else if (
      splitPathName.includes("user") &&
      splitPathName.includes("logs")
    ) {
      setSelectedKey("/user/logs");
    } else if (
      splitPathName.includes("admin") &&
      splitPathName.includes("home")
    ) {
      setSelectedKey("/admin/home");
    } else if (
      splitPathName.includes("admin") &&
      splitPathName.includes("properties")
    ) {
      setSelectedKey("/admin/properties");
    } else if (
      splitPathName.includes("admin") &&
      (splitPathName.includes("tax-inspectors") ||
        splitPathName.includes("edit-tax-inspector"))
    ) {
      setSelectedKey("/admin/tax-inspectors");
    } else if (
      splitPathName.includes("admin") &&
      (splitPathName.includes("eto") || splitPathName.includes("edit-eto"))
    ) {
      setSelectedKey("/admin/eto");
    } else if (
      splitPathName.includes("admin") &&
      splitPathName.includes("lookup-table")
    ) {
      setSelectedKey("/admin/lookup-table");
    } else if (splitPathName.includes("upload-lookup-data")) {
      setSelectedKey("/admin/upload-lookup-data");
    } else if (
      splitPathName.includes("admin") &&
      splitPathName.includes("overview")
    ) {
      setSelectedKey("/admin/overview");
    } else if (
      splitPathName.includes("admin") &&
      splitPathName.includes("ti-performance")
    ) {
      setSelectedKey("/admin/ti-performance");
    } else if (
      splitPathName.includes("admin") &&
      splitPathName.includes("activity-log")
    ) {
      setSelectedKey("/admin/activity-log");
    } else if (
      splitPathName.includes("admin") &&
      splitPathName.includes("admin-activity-logs")
    ) {
      setSelectedKey("/admin/admin-activity-logs");
    }
  }, [splitPathName]);

  const handleClick = (e) => {
    setSelectedKey(e.key);
  };

  if (isAdmin || isDistrictAdmin) {
    // TableOutlined
    return (
      <div>
        <div className="logo">
          {collapsed ? (
            <div className="logo-text-collapsed">{"ET & NC Admin"}</div>
          ) : (
            <>
              <div className="logo-text-1">{"ET & NC Admin"}</div>
            </>
          )}
        </div>
        <div className={collapsed ? "" : "side-menu-section"}>
          <Menu
            className="side-menu"
            mode="inline"
            selectedKeys={[selectedKey]}
            onClick={handleClick}
            inlineCollapsed={collapsed}
          >
            <Menu.Item
              key="/admin/home"
              className="sub-menu-single"
              icon={<TableOutlined />}
            >
              <span>Home</span>
              <Link to={"/admin/home"} />
            </Menu.Item>

            <Menu.Item
              key="/admin/properties"
              className="sub-menu-single"
              icon={<HomeOutlined />}
            >
              <span>Properties</span>
              <Link to={"/admin/properties"} />
            </Menu.Item>

            <SubMenu
              className="sub-menu"
              icon={<UsergroupDeleteOutlined />}
              title="Users"
              key="admin-users-submenu"
            >
              <Menu.Item
                key="/admin/tax-inspectors"
                className="side-menu-buttons"
              >
                <UserOutlined />
                <span>Tax Inspectors</span>
                <Link to={"/admin/tax-inspectors"} />{" "}
              </Menu.Item>
              <Menu.Item key="/admin/eto" className="side-menu-buttons">
                <UserOutlined />
                <span>ETO</span>
                <Link to={"/admin/eto"} />
              </Menu.Item>
              {!isDistrictAdmin && <Menu.Item key="/admin/distict-admin" className="side-menu-buttons">
                <UserOutlined />
                <span>District Admin</span>
                <Link to={"/admin/district-admin"} />
              </Menu.Item>}
            </SubMenu>

            <SubMenu
              className="sub-menu"
              icon={<TableOutlined />}
              title="Data Management"
              key="/data-management-submenu"
            >
              <Menu.Item
                key="/admin/lookup-table"
                className="sub-menu-single"
                icon={<TableOutlined />}
              >
                <span>Lookup Table</span>
                <Link to={"/admin/lookup-table"} />
              </Menu.Item>
              <Menu.Item
                key="/admin/upload-lookup-data"
                className="side-menu-buttons"
              >
                <UploadOutlined />
                <span>Upload Data</span>
                <Link to={"/admin/upload-lookup-data"} />
              </Menu.Item>
            </SubMenu>
            <SubMenu
              className="sub-menu"
              icon={<FileTextOutlined />}
              title="Reports"
              key="/admin-reports-submenu"
            >
              <Menu.Item key="/admin/overview" className="side-menu-buttons">
                <HistoryOutlined />
                <span>Overview</span>
                <Link to={"/admin/overview"} />{" "}
              </Menu.Item>
              <Menu.Item
                key="/reports/taxInspector"
                className="side-menu-buttons"
              >
                <HistoryOutlined />
                <span>TI Performance</span>
                <Link to={"/reports/taxInspector"} />
              </Menu.Item>
            </SubMenu>

            <Menu.Item key="/admin/activity-log" className="side-menu-buttons">
              <ContainerOutlined />
              <span>Activity Log</span>
              <Link to={"/admin/activity-log"} />{" "}
            </Menu.Item>

            {!isDistrictAdmin &&  <Menu.Item
              key="/admin/admin-activity-logs"
              className="side-menu-buttons"
            >
              <ContainerOutlined />
              <span>Admin Activity Log</span>
              <Link to={"/admin/admin-activity-logs"} />{" "}
            </Menu.Item>}
          </Menu>
        </div>
        {!collapsed && (
          <div
            style={{
              textAlign: "center",
              color: "gray",
              position: "absolute",
              bottom: 10,
              left: 75,
              lineHeight: "0px",
              fontSize: "11px",
            }}
          >
            <p>{process.env.REACT_APP_VERSION}</p>
            <p>{process.env.REACT_APP_ENIRONMENT}</p>
          </div>
        )}
      </div>
    );
  } else if (isInspector) {
    return (
      <div>
        <div className="logo">
          {collapsed ? (
            <div className="logo-text-collapsed">HIPT</div>
          ) : (
            <>
              <div className="logo-text-1">HIPT</div>
            </>
          )}
        </div>
        <div className={collapsed ? "" : "side-menu-section"}>
          <Menu
            className="side-menu"
            mode="inline"
            selectedKeys={[selectedKey]}
            onClick={handleClick}
            inlineCollapsed={collapsed}
          >
            <Menu.Item
              key="/tax-collection"
              className="sub-menu-single"
              icon={<FileTextOutlined />}
            >
              <span>Tax Collection</span>
              <Link to={"/tax-collection/unpaid"} />
            </Menu.Item>
          </Menu>
        </div>
        {!collapsed && (
          <div
            style={{
              textAlign: "center",
              color: "gray",
              position: "absolute",
              bottom: 10,
              left: 75,
              lineHeight: "0px",
              fontSize: "11px",
            }}
          >
            <p>{process.env.REACT_APP_VERSION}</p>
            <p>{process.env.REACT_APP_ENIRONMENT}</p>
          </div>
        )}
      </div>
    );
  } else if (isEto) {
    return (
      <div>
        <div className="logo">
          {collapsed ? (
            <div className="logo-text-collapsed">HIPT</div>
          ) : (
            <>
              <div className="logo-text-1">HIPT</div>
            </>
          )}
        </div>
        <div className={collapsed ? "" : "side-menu-section"}>
          <Menu
            className="side-menu"
            mode="inline"
            selectedKeys={[selectedKey]}
            onClick={handleClick}
            inlineCollapsed={collapsed}
          >
            <SubMenu
              className="sub-menu"
              icon={<HomeFilled />}
              title="Properties"
              key="eto-properties-submenu"
            >
              <Menu.Item key="/properties" className="side-menu-buttons">
                <UnorderedListOutlined />
                <span>Properties Listing</span>
                <Link to={"/properties/" + propertyKey} />{" "}
              </Menu.Item>
              <Menu.Item key="/detected" className="side-menu-buttons">
                <UnorderedListOutlined />
                <span>Detect Properties</span>
                <Link to={"/detected/search"} />
              </Menu.Item>
              <Menu.Item key="/search-property" className="side-menu-buttons">
                <SearchOutlined />
                <span>Search Properties</span>
                <Link to="/search-property" />
              </Menu.Item>
            </SubMenu>
            <Menu.Item
              key="/tax-collection"
              className="sub-menu-single"
              icon={<FileTextOutlined />}
            >
              <span>Tax Collection</span>
              <Link to={"/tax-collection/" + taxKey} />
            </Menu.Item>
            <SubMenu
              className="sub-menu"
              icon={<UserOutlined />}
              title="Reports"
              key="eto-reports-submenu"
            >
              <Menu.Item key="/reports/overview" className="side-menu-buttons">
                <HistoryOutlined />
                <span>Overview</span>
                <Link to="/reports/overview" />
              </Menu.Item>
              <Menu.Item
                key="/reports/taxInspector"
                className="side-menu-buttons"
              >
                <HistoryOutlined />
                <span>TI performance</span>
                <Link to="/reports/taxInspector" />
              </Menu.Item>
            </SubMenu>
            <SubMenu
              className="sub-menu"
              icon={<UserOutlined />}
              title="Users"
              key="user"
            >
              <Menu.Item key="/user/logs" className="side-menu-buttons">
                <HistoryOutlined />
                <span>Activity Log</span>
                <Link to="/user/logs" />
              </Menu.Item>
            </SubMenu>
          </Menu>
        </div>
        {!collapsed && (
          <div
            style={{
              textAlign: "center",
              color: "gray",
              position: "absolute",
              bottom: 10,
              left: 75,
              lineHeight: "0px",
              fontSize: "11px",
            }}
          >
            <p>{process.env.REACT_APP_VERSION}</p>
            <p>{process.env.REACT_APP_ENIRONMENT}</p>
          </div>
        )}
      </div>
    );
  }
};

const mapStateToProps = ({ user }) => ({ user });

const mapDispatchToProps = (dispatch) => ({
  logOut: bindActionCreators(userActions.logOut, dispatch),
});

Sidebar.propTypes = {
  logOut: PropTypes.func.isRequired,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Sidebar)
);
